import { Component, inject, input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { DONE } from './sublink-icon.constants';
import { IonIcon } from '@ionic/angular/standalone';

@Component({
  selector: 'app-sublink-icon',
  templateUrl: './sublink-icon.component.html',
  styleUrls: ['./sublink-icon.component.scss'],
  imports: [RouterLink, IonIcon],
})
export class SublinkIconComponent {
  private router = inject(Router);

  readonly displayText = input.required<string>();
  readonly route = input.required<string>();

  readonly DONE = DONE;

  get isActive(): any {
    return this.router.url.includes(this.route());
  }

  get link(): any {
    return `${this.route()}`;
  }
}
